/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Control } from './Control';
import {
    ControlFromJSON,
    ControlFromJSONTyped,
    ControlToJSON,
    ControlToJSONTyped,
} from './Control';
import type { Element } from './Element';
import {
    ElementFromJSON,
    ElementFromJSONTyped,
    ElementToJSON,
    ElementToJSONTyped,
} from './Element';

/**
 * On-the-fly rendered dashboard (structure + filled data) returned to the UI.
 * @export
 * @interface RenderedDashboard
 */
export interface RenderedDashboard {
    /**
     * 
     * @type {string}
     * @memberof RenderedDashboard
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof RenderedDashboard
     */
    name: string;
    /**
     * Product families this dashboard is about, so a client can scope its deployment picker to them. Empty means no product constraint.
     * @type {Array<string>}
     * @memberof RenderedDashboard
     */
    products?: Array<RenderedDashboardProductsEnum>;
    /**
     * 
     * @type {Array<Control>}
     * @memberof RenderedDashboard
     */
    controls?: Array<Control>;
    /**
     * 
     * @type {string}
     * @memberof RenderedDashboard
     */
    defaultTimeRange: string;
    /**
     * 
     * @type {Element}
     * @memberof RenderedDashboard
     */
    element: Element;
}


/**
 * @export
 */
export const RenderedDashboardProductsEnum = {
    Ring: 'RING',
    Adi: 'ADI',
    Artesca: 'ARTESCA'
} as const;
export type RenderedDashboardProductsEnum = typeof RenderedDashboardProductsEnum[keyof typeof RenderedDashboardProductsEnum];


/**
 * Check if a given object implements the RenderedDashboard interface.
 */
export function instanceOfRenderedDashboard(value: object): value is RenderedDashboard {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('defaultTimeRange' in value) || value['defaultTimeRange'] === undefined) return false;
    if (!('element' in value) || value['element'] === undefined) return false;
    return true;
}

export function RenderedDashboardFromJSON(json: any): RenderedDashboard {
    return RenderedDashboardFromJSONTyped(json, false);
}

export function RenderedDashboardFromJSONTyped(json: any, ignoreDiscriminator: boolean): RenderedDashboard {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'products': json['products'] == null ? undefined : json['products'],
        'controls': json['controls'] == null ? undefined : ((json['controls'] as Array<any>).map(ControlFromJSON)),
        'defaultTimeRange': json['defaultTimeRange'],
        'element': ElementFromJSON(json['element']),
    };
}

export function RenderedDashboardToJSON(json: any): RenderedDashboard {
    return RenderedDashboardToJSONTyped(json, false);
}

export function RenderedDashboardToJSONTyped(value?: RenderedDashboard | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'products': value['products'],
        'controls': value['controls'] == null ? undefined : ((value['controls'] as Array<any>).map(ControlToJSON)),
        'defaultTimeRange': value['defaultTimeRange'],
        'element': ElementToJSON(value['element']),
    };
}

